export default "__VITE_ASSET__d4b8f4a8__"